<div class="crear-orden-container">
  <h2 *ngIf="!modoDialog">Crear Orden Digital</h2>

  <!-- Formulario de creación -->
  <div *ngIf="!ordenGenerada">
    <!-- Buscador de Paciente (oculto si viene pre-seleccionado en modo dialog) -->
    <mat-card class="seccion-card" *ngIf="!pacienteInput">
      <mat-card-header>
        <mat-card-title>Paciente</mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <div *ngIf="!pacienteSeleccionado">
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Buscar paciente por nombre, apellido o DNI</mat-label>
            <input
              matInput
              [(ngModel)]="filtroPaciente"
              (ngModelChange)="filtrarPacientes()"
              autocomplete="off"
            />
            <mat-icon matSuffix>person_search</mat-icon>
          </mat-form-field>
          <div *ngIf="pacientesFiltrados.length > 0" class="pacientes-lista">
            <div
              *ngFor="let p of pacientesFiltrados"
              class="paciente-item"
              (click)="seleccionarPaciente(p)"
            >
              <mat-icon>person</mat-icon>
              <span
                >{{ p.surname }}, {{ p.name }} - DNI:
                {{ p.numeroDocumento }}</span
              >
            </div>
          </div>
        </div>

        <div *ngIf="pacienteSeleccionado" class="paciente-seleccionado">
          <div class="paciente-info">
            <strong
              >{{ pacienteSeleccionado.surname }},
              {{ pacienteSeleccionado.name }}</strong
            >
            <span>DNI: {{ pacienteSeleccionado.numeroDocumento }}</span>
          </div>
          <button
            mat-icon-button
            color="warn"
            (click)="limpiarPaciente()"
            matTooltip="Cambiar paciente"
          >
            <mat-icon>close</mat-icon>
          </button>
        </div>
      </mat-card-content>
    </mat-card>

    <!-- Diagnóstico -->
    <mat-card class="seccion-card">
      <mat-card-header>
        <mat-card-title>Diagnóstico</mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Diagnóstico</mat-label>
          <textarea
            matInput
            [formControl]="diagnosisControl"
            rows="3"
            placeholder="Ingrese el diagnóstico..."
          ></textarea>
          <mat-error *ngIf="diagnosisControl.hasError('required')">
            El diagnóstico es obligatorio
          </mat-error>
          <mat-error *ngIf="diagnosisControl.hasError('maxlength')">
            Máximo 500 caracteres
          </mat-error>
        </mat-form-field>
      </mat-card-content>
    </mat-card>

    <!-- Indicaciones / Medicación -->
    <mat-card class="seccion-card">
      <mat-card-header>
        <mat-card-title>Indicaciones / Medicación</mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Medicación e indicaciones</mat-label>
          <textarea
            matInput
            [formControl]="medicineControl"
            rows="6"
            placeholder="Ingrese la medicación e indicaciones..."
          ></textarea>
          <mat-error *ngIf="medicineControl.hasError('required')">
            Las indicaciones son obligatorias
          </mat-error>
          <mat-error *ngIf="medicineControl.hasError('maxlength')">
            Máximo 5000 caracteres
          </mat-error>
        </mat-form-field>
      </mat-card-content>
    </mat-card>

    <!-- Error -->
    <div *ngIf="error" class="error-message">
      <mat-icon>error</mat-icon>
      <span>{{ error }}</span>
    </div>

    <!-- Botón crear -->
    <button
      mat-raised-button
      color="primary"
      (click)="crearOrden()"
      [disabled]="procesando"
      class="btn-crear"
    >
      <mat-icon>send</mat-icon>
      {{ procesando ? "Creando..." : "Crear Orden" }}
    </button>
  </div>

  <!-- Resultado: orden generada -->
  <div *ngIf="ordenGenerada" class="resultado-container">
    <div class="resultado-header">
      <mat-icon class="success-icon">check_circle</mat-icon>
      <h3>Orden creada exitosamente</h3>
    </div>

    <mat-card class="orden-resultado-card">
      <mat-card-content>
        <p><strong>Diagnóstico:</strong> {{ ordenGenerada.diagnosis }}</p>
        <p><strong>Indicaciones:</strong> {{ ordenGenerada.medicine }}</p>
      </mat-card-content>
    </mat-card>

    <div class="acciones-resultado">
      <button
        mat-raised-button
        color="primary"
        (click)="nuevaOrden()"
        class="btn-nueva"
      >
        <mat-icon>add</mat-icon>
        Crear otra orden
      </button>
    </div>
  </div>
</div>

<ngx-spinner type="ball-scale-multiple">
  <p class="spinner-text">Creando orden...</p>
</ngx-spinner>
